import Scales_WorkspaceScalesPage from "@Scales/Pages/WorkspaceScalesPage.vue";

export const routes = [
    {
        path: "/scales/:workspaceId",
        component: Scales_WorkspaceScalesPage
    },
]
